import {CutAndEdgeOrderMFCGroup, CutAndEdgeOrderSheetMaterialGroup} from '../../types';

export const isMFCGroup = (group : (CutAndEdgeOrderMFCGroup | CutAndEdgeOrderSheetMaterialGroup)) : group is CutAndEdgeOrderMFCGroup => {

    if(['MFC_18', 'MFC_36'].includes(group.type)) return true;
    return false;
    
}
